// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--GKgnY","container_redesigned":"a10a3f92e9--container_redesigned--iXfaG","title":"a10a3f92e9--title--_Fq9_"};